import { useState, forwardRef } from "react";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

import { pazienHistory } from "common/components/pazienHistory";
import { useClickAwayDetector } from "common/hooks";

function navigateToBuManager() {
    pazienHistory.navigateWithParams("preferences/bumanager/unmapped", {
        trigger: true
    });
}

export const CreateBuDropdown = forwardRef((props, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    
    useClickAwayDetector(ref, () => setIsOpen(false));

    const { newFragment: buManagerLinkHref } = pazienHistory.buildFragment("preferences/bumanager/unmapped");

    return (
        <div ref={ref}>
            <DropdownChevron>
                <ChevronIcon icon={faChevronDown} $open={isOpen} onClick={() => setIsOpen(!isOpen)} />
            </DropdownChevron>
            
            {isOpen && (
                <Dropdown>
                    Visit the <a href={buManagerLinkHref} onClick={navigateToBuManager}>business unit manager</a> to group your MIDs into business units
                </Dropdown>
            )}
        </div>
    );
});

const DropdownChevron = styled.div`
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: -10px;
`;

const Dropdown = styled.div`
    position: absolute;
    top: 51px;
    left: 0;
    width: 300px;
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    z-index: 99;
    padding: 20px;
    font-size: ${(props) => props.theme.font("regular", "h4")}
`;

const ChevronIcon = styled(FontAwesomeIcon)`
    color: ${(props) => props.theme.colors["gray-light"]};
    transform: ${(props) => (props.$open ? "rotate(180deg)" : "none")};
    transition: 0.3s ease-in-out;

    &:hover {
        color: ${(props) => props.theme.colors["gray-dark"]};
    }
`;
